module.exports = require("../../canvg/index.js");